/*
  rk FAQ: sanfte Höhenanimation für <details data-rk-faq>.
  Ohne JS oder bei reduzierter Bewegung öffnet/schließt <details> nativ.
*/
(() => {
  if (window.RkFaq) return;
  window.RkFaq = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DURATION = 300;
  const EASING = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  const toggle = (details) => {
    const answer = details.querySelector('.rk-faq__answer');
    if (!answer) return;

    const isOpening = (details.dataset.rkState || (details.open ? 'open' : 'closed')) !== 'open';
    details.dataset.rkState = isOpening ? 'open' : 'closed';

    const from = details.open ? answer.getBoundingClientRect().height : 0;
    details.rkAnimation?.cancel();
    details.open = true;
    const to = isOpening ? answer.scrollHeight : 0;

    const animation = answer.animate({ height: [`${from}px`, `${to}px`] }, { duration: DURATION, easing: EASING });
    details.rkAnimation = animation;
    animation.onfinish = () => {
      details.rkAnimation = null;
      details.open = isOpening;
    };
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (details.matches?.('details[data-rk-faq]') && !details.rkAnimation) {
        details.dataset.rkState = details.open ? 'open' : 'closed';
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details[data-rk-faq] > summary');
    if (!summary || reducedMotion.matches) return;
    event.preventDefault();
    toggle(summary.parentElement);
  });
})();
